import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container mx-auto px-4 py-8" }
const _hoisted_2 = { class: "mb-8" }
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" }
const _hoisted_6 = { class: "bg-dark-secondary rounded-lg p-6" }
const _hoisted_7 = {
  key: 0,
  class: "mt-2 space-y-2"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "mt-2 text-3xl font-semibold text-white" }
const _hoisted_10 = { class: "bg-dark-secondary rounded-lg p-6" }
const _hoisted_11 = {
  key: 0,
  class: "mt-2 space-y-2"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "mt-2 text-3xl font-semibold text-white" }
const _hoisted_14 = { class: "bg-dark-secondary rounded-lg p-6" }
const _hoisted_15 = {
  key: 0,
  class: "mt-2 space-y-2"
}
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "mt-2 text-3xl font-semibold text-white" }
const _hoisted_18 = { class: "bg-dark-secondary rounded-lg p-6 mb-8 relative" }
const _hoisted_19 = { class: "space-y-4" }
const _hoisted_20 = { class: "flex gap-4" }
const _hoisted_21 = { class: "relative flex-1" }
const _hoisted_22 = { class: "relative" }
const _hoisted_23 = {
  key: 0,
  class: "date-picker absolute left-0 top-full mt-2 z-10 bg-dark-secondary rounded-xl shadow-lg border border-gray-700 p-4 min-w-[320px]"
}
const _hoisted_24 = { class: "flex items-center justify-between mb-4" }
const _hoisted_25 = { class: "text-sm font-medium text-gray-100" }
const _hoisted_26 = { class: "grid grid-cols-7 gap-1 mb-4" }
const _hoisted_27 = ["onClick", "disabled"]
const _hoisted_28 = { class: "grid grid-cols-2 gap-2 mb-4" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "flex justify-between border-t border-gray-700 pt-4" }
const _hoisted_31 = { class: "flex items-center gap-3 pl-4 border-l border-gray-700" }
const _hoisted_32 = { class: "flex rounded-lg border border-gray-700 p-1" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = {
  key: 0,
  class: "relative flex h-2 w-2"
}
const _hoisted_35 = { class: "flex items-center gap-2 pl-3" }
const _hoisted_36 = { class: "flex gap-4" }
const _hoisted_37 = { class: "relative categories-filter flex-1" }
const _hoisted_38 = { class: "flex flex-wrap items-center gap-2 rounded-lg border border-gray-700 bg-dark p-2 min-h-[40px] focus-within:border-primary focus-within:ring-1 focus-within:ring-primary" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = {
  key: 0,
  class: "absolute left-0 right-0 top-full z-10 mt-1 max-h-48 overflow-y-auto rounded-lg border border-gray-700 bg-dark-secondary shadow-lg"
}
const _hoisted_41 = ["onClick"]
const _hoisted_42 = {
  key: 0,
  class: "flex items-center justify-between border-t border-gray-700 pt-3"
}
const _hoisted_43 = { class: "text-sm text-gray-400" }
const _hoisted_44 = {
  key: 0,
  class: "mb-4 flex items-center justify-between"
}
const _hoisted_45 = { class: "flex items-center gap-2 text-sm text-gray-400" }
const _hoisted_46 = { class: "text-white font-medium" }
const _hoisted_47 = { class: "text-gray-500" }
const _hoisted_48 = { class: "flex items-center gap-2" }
const _hoisted_49 = ["disabled"]
const _hoisted_50 = ["disabled"]
const _hoisted_51 = ["disabled"]
const _hoisted_52 = {
  key: 1,
  class: "overflow-x-auto"
}
const _hoisted_53 = { class: "bg-dark-secondary rounded-xl shadow-lg" }
const _hoisted_54 = { class: "min-w-full" }
const _hoisted_55 = { class: "divide-y divide-gray-700/50" }
const _hoisted_56 = {
  key: 2,
  class: "overflow-x-auto"
}
const _hoisted_57 = { class: "bg-dark-secondary rounded-xl shadow-lg" }
const _hoisted_58 = { class: "min-w-full" }
const _hoisted_59 = { class: "divide-y divide-gray-700/50" }
const _hoisted_60 = {
  key: 0,
  class: "hover:bg-gray-700/20 transition-colors"
}
const _hoisted_61 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-300" }
const _hoisted_62 = { class: "px-6 py-4 text-sm text-gray-300" }
const _hoisted_63 = { class: "flex items-start gap-2" }
const _hoisted_64 = { class: "break-words min-w-[200px] max-w-[300px]" }
const _hoisted_65 = {
  key: 0,
  class: "relative group flex-shrink-0 mt-0.5"
}
const _hoisted_66 = { class: "px-6 py-4 text-sm text-gray-300" }
const _hoisted_67 = { class: "min-w-[200px] max-w-[300px]" }
const _hoisted_68 = ["href"]
const _hoisted_69 = { class: "break-words" }
const _hoisted_70 = {
  key: 1,
  class: "text-gray-500"
}
const _hoisted_71 = { class: "px-6 py-4 text-sm" }
const _hoisted_72 = {
  key: 0,
  class: "flex flex-wrap gap-1"
}
const _hoisted_73 = {
  key: 1,
  class: "text-gray-500"
}
const _hoisted_74 = { class: "px-6 py-4 text-sm text-center" }
const _hoisted_75 = {
  key: 0,
  class: "inline-flex items-center justify-center w-8 h-8 rounded-full bg-emerald-500/10 text-emerald-500"
}
const _hoisted_76 = {
  key: 1,
  class: "text-gray-500"
}
const _hoisted_77 = { class: "px-4 py-4 whitespace-nowrap text-right text-sm" }
const _hoisted_78 = { class: "flex items-center gap-2 justify-end" }
const _hoisted_79 = ["onClick", "title"]
const _hoisted_80 = ["onClick"]
const _hoisted_81 = ["onClick"]
const _hoisted_82 = {
  key: 0,
  class: "mt-6 flex items-center justify-between border-t border-gray-700 px-6 py-4"
}
const _hoisted_83 = { class: "flex items-center gap-2 text-sm text-gray-400" }
const _hoisted_84 = { class: "text-white font-medium" }
const _hoisted_85 = { class: "text-white font-medium" }
const _hoisted_86 = { class: "flex items-center gap-2" }
const _hoisted_87 = ["disabled"]
const _hoisted_88 = ["disabled"]
const _hoisted_89 = ["disabled"]
const _hoisted_90 = { class: "flex items-center justify-between w-full" }
const _hoisted_91 = { class: "text-xs text-gray-500" }
const _hoisted_92 = ["disabled"]
const _hoisted_93 = {
  key: 0,
  class: "animate-spin h-4 w-4",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_94 = {
  key: 1,
  class: "h-4 w-4",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_95 = {
  key: 0,
  class: "grid grid-cols-12 gap-6"
}
const _hoisted_96 = { class: "col-span-4 space-y-6 border-r border-gray-700 pr-6" }
const _hoisted_97 = { class: "space-y-4" }
const _hoisted_98 = { class: "pb-4 border-b border-gray-700" }
const _hoisted_99 = { class: "flex items-center justify-between mb-2" }
const _hoisted_100 = { class: "text-sm text-gray-400" }
const _hoisted_101 = { class: "flex items-start gap-2" }
const _hoisted_102 = { class: "text-lg text-white font-medium break-all" }
const _hoisted_103 = {
  key: 0,
  class: "relative group flex-shrink-0 mt-1"
}
const _hoisted_104 = { class: "pb-4 border-b border-gray-700" }
const _hoisted_105 = { class: "flex justify-between items-start" }
const _hoisted_106 = {
  key: 0,
  class: "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-emerald-500/10 text-emerald-500"
}
const _hoisted_107 = {
  key: 1,
  class: "text-gray-500"
}
const _hoisted_108 = { key: 0 }
const _hoisted_109 = { class: "text-white" }
const _hoisted_110 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_111 = ["href"]
const _hoisted_112 = { class: "pb-4 border-b border-gray-700" }
const _hoisted_113 = { class: "mt-2" }
const _hoisted_114 = {
  key: 0,
  class: "flex flex-wrap gap-2"
}
const _hoisted_115 = ["onClick"]
const _hoisted_116 = {
  key: 1,
  class: "text-gray-500"
}
const _hoisted_117 = { class: "pb-4 border-b border-gray-700" }
const _hoisted_118 = ["href"]
const _hoisted_119 = { class: "break-words" }
const _hoisted_120 = {
  key: 1,
  class: "mt-2 text-gray-500"
}
const _hoisted_121 = {
  key: 0,
  class: "flex flex-wrap gap-2"
}
const _hoisted_122 = {
  key: 1,
  class: "text-gray-500"
}
const _hoisted_123 = {
  key: 0,
  class: "space-y-4"
}
const _hoisted_124 = { key: 0 }
const _hoisted_125 = { class: "mt-2 flex flex-wrap gap-2" }
const _hoisted_126 = {
  key: 1,
  class: "pb-2"
}
const _hoisted_127 = { class: "mt-2 flex items-center gap-2" }
const _hoisted_128 = { class: "inline-flex items-center px-2.5 py-1 rounded-md text-sm font-medium bg-blue-500/10 text-blue-400" }
const _hoisted_129 = {
  key: 0,
  class: "text-sm text-gray-400"
}
const _hoisted_130 = { class: "col-span-8 space-y-6" }
const _hoisted_131 = {
  key: 0,
  class: "space-y-4"
}
const _hoisted_132 = { class: "text-sm font-medium text-gray-400" }
const _hoisted_133 = {
  key: 0,
  class: "mt-3 space-y-3"
}
const _hoisted_134 = {
  key: 1,
  class: "mt-2 flex items-center"
}
const _hoisted_135 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5 mr-2 text-green-500",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_136 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5 mr-2 text-red-500",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_137 = { class: "text-white" }
const _hoisted_138 = {
  key: 2,
  class: "mt-2 text-lg text-white"
}
const _hoisted_139 = {
  key: 3,
  class: "mt-2 text-lg text-white"
}
const _hoisted_140 = {
  key: 1,
  class: "space-y-4"
}
const _hoisted_141 = { class: "text-sm font-medium text-gray-400" }
const _hoisted_142 = {
  key: 0,
  class: "mt-3 space-y-3"
}
const _hoisted_143 = {
  key: 1,
  class: "mt-2 flex items-center"
}
const _hoisted_144 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5 mr-2 text-blue-500",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_145 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5 mr-2 text-gray-500",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_146 = { class: "text-white" }
const _hoisted_147 = {
  key: 2,
  class: "mt-2 text-lg text-white"
}
const _hoisted_148 = {
  key: 3,
  class: "mt-2 text-lg text-white"
}

import { ref, computed, onMounted, onBeforeUnmount, watch } from 'vue'
import { collection, query, where, orderBy, getDocs, limit, startAfter, QueryDocumentSnapshot, Timestamp, doc, deleteDoc, updateDoc } from 'firebase/firestore'
import { httpsCallable } from 'firebase/functions'
import { db, functions } from '@/config/firebase'
import { useOrgStore } from '@/stores/org'
import BaseModal from '@/components/ui/BaseModal.vue'

// State
import { useRoute } from 'vue-router'

export default /*@__PURE__*/_defineComponent({
  __name: 'SearchesView',
  setup(__props) {

const searches = ref<any[]>([])
const loading = ref(true)
const searchTerm = ref('')
const includeSpam = ref(false)

// Pagination state
const pageSize = ref(25)
const currentPage = ref(1)
const lastDocSnapshot = ref<QueryDocumentSnapshot | null>(null)
const pageHistory = ref<QueryDocumentSnapshot[]>([]) // Track document snapshots for each page
const totalFilteredCount = ref<number | null>(null) // Total count of filtered results

// Metrics state
const metrics = ref({
  searchVolume: 0,
  averageOrderValue: 0,
  conversionRate: 0
})
const loadingMetrics = ref(true) // Start with loading state
const metricsInitialized = ref(false) // Track if metrics have been fetched at least once

// Date state
const showDatePicker = ref(false)
const currentDate = ref(new Date())
const selectedStartDate = ref<Date | null>(null)
const selectedEndDate = ref<Date | null>(null)
const tempStartDate = ref<Date | null>(null)
const tempEndDate = ref<Date | null>(null)

const datePresets = [
  { value: '7', label: 'Last 7 days' },
  { value: '30', label: 'Last 30 days' },
  { value: '90', label: 'Last 90 days' },
  { value: 'thisMonth', label: 'This month' }
]

// Calendar computed properties
const currentMonthYear = computed(() => {
  return new Intl.DateTimeFormat('en-US', { 
    month: 'long',
    year: 'numeric'
  }).format(currentDate.value)
})

const calendarDays = computed(() => {
  const year = currentDate.value.getFullYear()
  const month = currentDate.value.getMonth()
  const firstDay = new Date(year, month, 1)
  const lastDay = new Date(year, month + 1, 0)
  
  // Get days from previous month
  const daysFromPrevMonth = firstDay.getDay()
  const prevMonth = new Date(year, month, 0)
  const prevMonthDays = []
  
  for (let i = daysFromPrevMonth - 1; i >= 0; i--) {
    prevMonthDays.push({
      date: new Date(year, month - 1, prevMonth.getDate() - i),
      day: prevMonth.getDate() - i,
      isCurrentMonth: false
    })
  }
  
  // Get days from current month
  const currentMonthDays = []
  for (let i = 1; i <= lastDay.getDate(); i++) {
    currentMonthDays.push({
      date: new Date(year, month, i),
      day: i,
      isCurrentMonth: true
    })
  }
  
  // Get days from next month
  const daysFromNextMonth = 42 - (prevMonthDays.length + currentMonthDays.length)
  const nextMonthDays = []
  
  for (let i = 1; i <= daysFromNextMonth; i++) {
    nextMonthDays.push({
      date: new Date(year, month + 1, i),
      day: i,
      isCurrentMonth: false
    })
  }
  
  return [...prevMonthDays, ...currentMonthDays, ...nextMonthDays]
})

const formatDateRange = computed(() => {
  if (!selectedStartDate.value || !selectedEndDate.value) {
    return 'Select date range'
  }
  
  // Format date without time for the range selector
  const formatDateNoTime = (date: Date) => {
    return new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric'
    }).format(date)
  }
  return `${formatDateNoTime(selectedStartDate.value)} - ${formatDateNoTime(selectedEndDate.value)}`
})

// Calendar methods
const changeMonth = (delta: number) => {
  const newDate = new Date(currentDate.value)
  newDate.setMonth(newDate.getMonth() + delta)
  currentDate.value = newDate
}

const selectDate = (date: { date: Date, day: number, isCurrentMonth: boolean }) => {
  if (!date.isCurrentMonth) return
  
  if (!tempStartDate.value || (tempStartDate.value && tempEndDate.value)) {
    tempStartDate.value = date.date
    tempEndDate.value = null
  } else {
    if (date.date < tempStartDate.value) {
      tempStartDate.value = date.date
    } else {
      tempEndDate.value = date.date
    }
  }
}

const isSelectedDate = (date: { date: Date }) => {
  if (!tempStartDate.value) return false
  
  const isStart = tempStartDate.value.toDateString() === date.date.toDateString()
  const isEnd = tempEndDate.value?.toDateString() === date.date.toDateString()
  
  return isStart || isEnd
}

const isInRange = (date: { date: Date }) => {
  if (!tempStartDate.value || !tempEndDate.value) return false
  
  return date.date > tempStartDate.value && date.date < tempEndDate.value
}

const selectDatePreset = (preset: { value: string, label: string }) => {
  const end = new Date()
  const start = new Date()
  
  if (preset.value === 'thisMonth') {
    start.setDate(1)
  } else {
    start.setDate(start.getDate() - parseInt(preset.value))
  }
  
  tempStartDate.value = start
  tempEndDate.value = end
  
  // Auto-apply preset selection
  applyDateRange()
}

const setToday = () => {
  const today = new Date()
  tempStartDate.value = today
  tempEndDate.value = today
}

const applyDateRange = () => {
  if (tempStartDate.value && tempEndDate.value) {
    selectedStartDate.value = tempStartDate.value
    selectedEndDate.value = tempEndDate.value
    showDatePicker.value = false
    fetchSearches()
  }
}

// Initialize with last 7 days
onMounted(() => {
  selectDatePreset(datePresets[1])
})

// Filter state
const filters = ref({
  categories: [] as string[],
  conversion: '', // '' = all, 'converted' = converted only, 'not_converted' = not converted only
})

// Categories filter state
const categorySearchQuery = ref('')
const showCategorySuggestions = ref(false)

// Close dropdowns when clicking outside
const handleClickOutside = (e: MouseEvent) => {
  const target = e.target as HTMLElement
  
  // Handle category suggestions
  if (!target.closest('.categories-filter')) {
    showCategorySuggestions.value = false
  }
  
  // Handle date picker
  if (!target.closest('.date-picker') && !target.closest('.date-picker-trigger')) {
    showDatePicker.value = false
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside)
  // Clear debounce timer on unmount
  if (searchTermDebounceTimer) {
    clearTimeout(searchTermDebounceTimer)
    searchTermDebounceTimer = null
  }
})

// Filter options
const conversionFilters = [
  { value: '', label: 'All' },
  { value: 'converted', label: 'Converted' },
  { value: 'not_converted', label: 'Not Converted' }
]

// Available categories computed from search data
const availableCategories = computed(() => {
  const categories = new Set<string>()
  searches.value.forEach(search => {
    if (search.enriched_data?.enriched_categories) {
      search.enriched_data.enriched_categories.forEach((cat: string) => categories.add(cat))
    }
  })
  return Array.from(categories).sort()
})

// Filtered available categories based on search
const filteredAvailableCategories = computed(() => {
  if (!categorySearchQuery.value) return availableCategories.value
  const query = categorySearchQuery.value.toLowerCase()
  return availableCategories.value.filter(
    category => category.toLowerCase().includes(query) && !filters.value.categories.includes(category)
  )
})

// Category methods
const selectCategory = (category: string) => {
  if (!filters.value.categories.includes(category)) {
    filters.value.categories.push(category)
  }
  categorySearchQuery.value = ''
  showCategorySuggestions.value = true
  // Keep focus on input after selection
  const input = document.querySelector('.categories-filter input') as HTMLInputElement
  if (input) {
    input.focus()
  }
  // Watch will trigger metrics update
}

const handleBackspace = () => {
  if (categorySearchQuery.value === '' && filters.value.categories.length > 0) {
    const lastCategory = filters.value.categories[filters.value.categories.length - 1]
    toggleCategory(lastCategory)
  }
}

const toggleCategory = (category: string) => {
  const index = filters.value.categories.indexOf(category)
  if (index === -1) {
    filters.value.categories.push(category)
  } else {
    filters.value.categories.splice(index, 1)
  }
  categorySearchQuery.value = ''
  showCategorySuggestions.value = true
  // Watch will trigger metrics update
}

const toggleConversionFilter = (status: string) => {
  filters.value.conversion = filters.value.conversion === status ? '' : status
  // Watch will trigger metrics update
}

const toggleIncludeSpam = () => {
  includeSpam.value = !includeSpam.value
  // Watch will trigger metrics update
}

// Modal state
const showDetailsModal = ref(false)
const selectedSearch = ref<any>(null)
const isDeleting = ref(false)

// Delete search handlers
const handleDeleteSearch = (search: any) => {
  if (confirm('Are you sure you want to delete this search?')) {
    deleteSearch(search)
  }
}

const deleteSearch = async (search: any) => {
  if (!search?.id || isDeleting.value || !orgStore.orgData?.id) return

  try {
    isDeleting.value = true
    const searchRef = doc(db, 'searches', search.id)
    await deleteDoc(searchRef)
    
    // Remove from local state
    searches.value = searches.value.filter(s => s.id !== search.id)
    
    // If the deleted search is currently shown in the modal, close it
    if (selectedSearch.value?.id === search.id) {
      closeDetailsModal()
    }
  } catch (error) {
    console.error('Error deleting search:', error)
  } finally {
    isDeleting.value = false
  }
}

  // Toggle spam status
  const toggleSpamStatus = async (search: any) => {
    if (!search?.id || !orgStore.orgData?.id) return
    
    try {
      const searchRef = doc(db, 'searches', search.id)
      const newSpamStatus = !search.enriched_data?.is_potential_spam
      
      await updateDoc(searchRef, {
        'enriched_data.is_potential_spam': newSpamStatus
      })
      
      // Update local state
      const updatedSearch = searches.value.find(s => s.id === search.id)
      if (updatedSearch) {
        if (!updatedSearch.enriched_data) {
          updatedSearch.enriched_data = {}
        }
        updatedSearch.enriched_data.is_potential_spam = newSpamStatus
      }
    } catch (error) {
      console.error('Error updating spam status:', error)
    }
  }

  // Has active filters
const hasActiveFilters = computed(() => {
  return searchTerm.value || 
         filters.value.categories.length > 0 ||
         filters.value.conversion !== ''
})

// Clear filters
const clearFilters = () => {
  searchTerm.value = ''
  filters.value.categories = []
  filters.value.conversion = ''
  categorySearchQuery.value = ''
  // Watches will trigger metrics update
  currentPage.value = 1
}

// Modal methods
const openDetailsModal = (search: any) => {
  selectedSearch.value = search
  showDetailsModal.value = true
}

const closeDetailsModal = () => {
  showDetailsModal.value = false
  selectedSearch.value = null
}

const filterByCategory = (category: string) => {
  // Clear existing categories and add the new one
  filters.value.categories = [category]
  // Close the modal
  closeDetailsModal()
}

// Store
const orgStore = useOrgStore()

// URL helper
const getFullProductUrl = (productUrl: string) => {
  if (!productUrl) return ''
  if (productUrl.startsWith('http')) return productUrl
  
  const shopifyDomain = orgStore.orgData?.keys?.shopify?.storeName
  if (!shopifyDomain) return productUrl
  
  // Remove leading slash if present
  const cleanProductUrl = productUrl.startsWith('/') ? productUrl.slice(1) : productUrl
  return `https://${shopifyDomain}.myshopify.com/${cleanProductUrl}`
}

// Fetch searches with Firestore pagination
// When text search or category filters are active, fetch all results and paginate client-side
// Otherwise, use Firestore pagination for better performance
const fetchSearches = async (resetPagination = false) => {
  try {
    loading.value = true
    const orgId = orgStore.orgData?.id

    if (!orgId) {
      console.error('No organization ID found')
      return
    }

    if (!selectedStartDate.value || !selectedEndDate.value) return
    
    const startDate = new Date(selectedStartDate.value)
    startDate.setHours(0, 0, 0, 0) // Start of day
    
    const endDate = new Date(selectedEndDate.value)
    endDate.setHours(23, 59, 59, 999) // End of day

    const searchesRef = collection(db, 'searches')
    
    // If text search or category filters are active, fetch all results (no limit) for client-side filtering
    // Otherwise, use Firestore pagination
    const hasTextSearch = searchTerm.value && searchTerm.value.trim().length > 0
    const hasCategoryFilters = filters.value.categories.length > 0
    const needsAllResults = hasTextSearch || hasCategoryFilters
    
    // Build base query constraints
    const baseConstraints: any[] = [
      where('org_id', '==', orgId),
      where('created_at', '>=', startDate),
      where('created_at', '<=', endDate)
    ]
    
    // Add conversion filter to Firestore query if active
    if (filters.value.conversion === 'converted') {
      baseConstraints.push(where('has_converted', '==', true))
    } else if (filters.value.conversion === 'not_converted') {
      baseConstraints.push(where('has_converted', '==', false))
    }
    
    if (needsAllResults) {
      // Fetch all results when text search or category filters are active
      baseConstraints.push(orderBy('created_at', 'desc'))
      
      const q = query(searchesRef, ...baseConstraints)
      const querySnapshot = await getDocs(q)
      
      searches.value = querySnapshot.docs.map(doc => {
        const data = doc.data()
        return {
          id: doc.id,
          ...data
        }
      })
      
      // Reset pagination state for client-side pagination
      pageHistory.value = []
      lastDocSnapshot.value = null
      hasMorePages.value = false // Will be computed based on filtered results
    } else {
      // Use Firestore pagination when no text search or category filters
      baseConstraints.push(orderBy('created_at', 'desc'))
      baseConstraints.push(limit(pageSize.value))

      // If resetting pagination or going to first page, start from beginning
      if (resetPagination || currentPage.value === 1) {
        pageHistory.value = []
        lastDocSnapshot.value = null
      } else {
        // For forward navigation, use the last document from the previous page
        // For backward navigation, use the snapshot from two pages back
        const snapshotIndex = currentPage.value - 2
        if (snapshotIndex >= 0 && snapshotIndex < pageHistory.value.length) {
          baseConstraints.push(startAfter(pageHistory.value[snapshotIndex]))
        }
      }

      const q = query(searchesRef, ...baseConstraints)
      const querySnapshot = await getDocs(q)

      // Store the last document snapshot for next page
      if (querySnapshot.docs.length > 0) {
        const lastDoc = querySnapshot.docs[querySnapshot.docs.length - 1]
        // Update page history - store snapshot for the current page
        const currentPageIndex = currentPage.value - 1
        if (currentPageIndex >= pageHistory.value.length) {
          // Adding a new page, append the snapshot
          pageHistory.value.push(lastDoc)
        } else {
          // Navigating backwards, truncate and add new snapshot
          pageHistory.value = pageHistory.value.slice(0, currentPageIndex)
          pageHistory.value.push(lastDoc)
        }
        lastDocSnapshot.value = lastDoc
      } else {
        lastDocSnapshot.value = null
      }

      searches.value = querySnapshot.docs.map(doc => {
        const data = doc.data()
        return {
          id: doc.id,
          ...data
        }
      })

      // Check if there are more pages
      hasMorePages.value = querySnapshot.docs.length === pageSize.value
    }

  } catch (error) {
    console.error('Error fetching searches:', error)
  } finally {
    loading.value = false
  }
}

// Fetch metrics from backend
const fetchMetrics = async () => {
  if (!orgStore.orgData?.id || !selectedStartDate.value || !selectedEndDate.value) {
    // Don't clear loading state if dates aren't set yet - they might be set soon
    // Only clear if org is missing (which means we can't fetch)
    if (!orgStore.orgData?.id) {
      loadingMetrics.value = false
    }
    return
  }
  
  try {
    loadingMetrics.value = true
    
    const startDate = new Date(selectedStartDate.value)
    startDate.setHours(0, 0, 0, 0)
    
    const endDate = new Date(selectedEndDate.value)
    endDate.setHours(23, 59, 59, 999)

    const requestData = {
      org_id: orgStore.orgData.id,
      start_date: startDate.toISOString(),
      end_date: endDate.toISOString(),
      search_term: searchTerm.value || undefined,
      categories: filters.value.categories.length > 0 ? filters.value.categories : undefined,
      conversion: filters.value.conversion || undefined,
      include_spam: includeSpam.value
    }
    
    console.log('[DEBUG] Fetching metrics with filters:', requestData)

    const getSearchMetrics = httpsCallable(functions, 'getSearchMetrics')
    const result = await getSearchMetrics(requestData)
    
    const data = result.data as { success: boolean; metrics: any }
    
    console.log('[DEBUG] Metrics received:', data.metrics)
    
    if (data.success && data.metrics) {
      metrics.value = {
        searchVolume: data.metrics.searchVolume || 0,
        averageOrderValue: data.metrics.averageOrderValue || 0,
        conversionRate: data.metrics.conversionRate || 0
      }
      metricsInitialized.value = true
    }
  } catch (error) {
    console.error('Error fetching metrics:', error)
    metricsInitialized.value = true // Mark as initialized even on error to prevent infinite loading
  } finally {
    loadingMetrics.value = false
  }
}

// Metric computations
const searchVolume = computed(() => metrics.value.searchVolume)

const formattedAOV = computed(() => {
  if (metrics.value.averageOrderValue === 0) return '$0'
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(metrics.value.averageOrderValue)
})

const formattedConversionRate = computed(() => {
  return `${metrics.value.conversionRate.toFixed(1)}%`
})

// Paginated searches - apply client-side filters to Firestore results
// When text search or category filters are active, paginate filtered results client-side
// Otherwise, show Firestore paginated results with other filters applied
const paginatedSearches = computed(() => {
  const hasTextSearch = searchTerm.value && searchTerm.value.trim().length > 0
  const hasCategoryFilters = filters.value.categories.length > 0
  const needsClientSidePagination = hasTextSearch || hasCategoryFilters
  
  // When using Firestore pagination, conversion filter is already applied in the query
  // Only apply conversion filter client-side when fetching all results (text search or category filters active)
  
  // Apply filters
  let filtered = searches.value.filter(search => {
    // Text search filter
    const matchesSearch = !searchTerm.value || 
      search.query?.toLowerCase().includes(searchTerm.value.toLowerCase())

    // Categories filter
    const matchesCategories = filters.value.categories.length === 0 || 
      filters.value.categories.every(category => 
        search.enriched_data?.enriched_categories?.includes(category)
      )

    // Conversion filter - only apply client-side when using client-side pagination
    // (when using Firestore pagination, conversion is already filtered in the query)
    const matchesConversion = needsClientSidePagination 
      ? (!filters.value.conversion || 
         (filters.value.conversion === 'converted' && search.has_converted) ||
         (filters.value.conversion === 'not_converted' && !search.has_converted))
      : true // Already filtered in Firestore query

    // Spam filter
    const matchesSpam = includeSpam.value || !search.enriched_data?.is_potential_spam

    return matchesSearch && matchesCategories && matchesConversion && matchesSpam
  })
  
  // If text search or category filters are active, paginate client-side
  // Otherwise, return all filtered results (Firestore pagination already applied)
  if (needsClientSidePagination) {
    const start = (currentPage.value - 1) * pageSize.value
    const end = start + pageSize.value
    return filtered.slice(start, end)
  }
  
  // No text search or category filters - return filtered Firestore results
  return filtered
})

// Pagination computed - using Firestore pagination or client-side pagination
const hasTextSearch = computed(() => searchTerm.value && searchTerm.value.trim().length > 0)
const hasCategoryFilters = computed(() => filters.value.categories.length > 0)
const needsClientSidePagination = computed(() => hasTextSearch.value || hasCategoryFilters.value)

const filteredSearchesCount = computed(() => {
  // Only used for client-side pagination, so conversion filter should be applied client-side
  const hasTextSearch = searchTerm.value && searchTerm.value.trim().length > 0
  const hasCategoryFilters = filters.value.categories.length > 0
  const needsClientSidePagination = hasTextSearch || hasCategoryFilters
  
  return searches.value.filter(search => {
    const matchesSearch = !searchTerm.value || 
      search.query?.toLowerCase().includes(searchTerm.value.toLowerCase())
    const matchesCategories = filters.value.categories.length === 0 || 
      filters.value.categories.every(category => 
        search.enriched_data?.enriched_categories?.includes(category)
      )
    // Only apply conversion filter client-side when using client-side pagination
    // (when using Firestore pagination, conversion is already filtered in the query)
    const matchesConversion = needsClientSidePagination
      ? (!filters.value.conversion || 
         (filters.value.conversion === 'converted' && search.has_converted) ||
         (filters.value.conversion === 'not_converted' && !search.has_converted))
      : true // Already filtered in Firestore query
    const matchesSpam = includeSpam.value || !search.enriched_data?.is_potential_spam
    return matchesSearch && matchesCategories && matchesConversion && matchesSpam
  }).length
})

const hasPreviousPage = computed(() => currentPage.value > 1)
const hasMorePages = ref(false) // Track if there are more pages from Firestore
const hasNextPage = computed(() => {
  if (needsClientSidePagination.value) {
    // Client-side pagination: check if there are more filtered results
    return currentPage.value * pageSize.value < filteredSearchesCount.value
  }
  // Firestore pagination: use the hasMorePages ref
  return hasMorePages.value
})

// Pagination methods for Firestore pagination or client-side pagination
const nextPage = async () => {
  if (hasNextPage.value) {
    currentPage.value++
    // Only fetch from Firestore if not using client-side pagination
    if (!needsClientSidePagination.value) {
      await fetchSearches()
    }
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
}

const previousPage = async () => {
  if (hasPreviousPage.value) {
    currentPage.value--
    // Only fetch from Firestore if not using client-side pagination
    if (!needsClientSidePagination.value) {
      await fetchSearches()
    }
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
}

const goToFirstPage = async () => {
  if (currentPage.value !== 1) {
    currentPage.value = 1
    // Only fetch from Firestore if not using client-side pagination
    if (!needsClientSidePagination.value) {
      await fetchSearches(true)
    }
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
}

// Methods
const refreshSearches = async () => {
  currentPage.value = 1
  await fetchSearches(true) // Reset pagination
  await fetchMetrics()
}

// Debounce timer for search term
let searchTermDebounceTimer: ReturnType<typeof setTimeout> | null = null

// Watch searchTerm with debounce (500ms delay)
watch(searchTerm, () => {
  console.log('[DEBUG] Search term changed, debouncing fetch')
  // Show loading state immediately when user types
  loading.value = true
  loadingMetrics.value = true
  // Clear existing timer
  if (searchTermDebounceTimer) {
    clearTimeout(searchTermDebounceTimer)
  }
  // Set new timer
  searchTermDebounceTimer = setTimeout(async () => {
    currentPage.value = 1
    // Refetch searches when text search changes (to get all results for client-side filtering)
    await fetchSearches(true) // Reset pagination
    fetchMetrics() // Fetch metrics independently, don't block page
    searchTermDebounceTimer = null
  }, 500) // 500ms debounce
})

// Watch other filters without debounce (immediate update)
watch(
  () => ({
    categories: filters.value.categories,
    conversion: filters.value.conversion,
    includeSpam: includeSpam.value
  }),
  () => {
    console.log('[DEBUG] Filters changed, fetching metrics immediately', {
      categories: filters.value.categories,
      conversion: filters.value.conversion,
      includeSpam: includeSpam.value
    })
    currentPage.value = 1
    // Refetch searches to reset pagination when filters change
    fetchSearches(true) // Reset pagination
    fetchMetrics()
  },
  { deep: true }
)

const formatKey = (key: string | number): string => {
  const keyStr = String(key)
  return keyStr
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

const formatCategory = (category: string): string => {
  if (!category) return ''
  // Replace hyphens and underscores with spaces, then capitalize first letter of each word
  return category
    .replace(/[-_]/g, ' ')
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
}

const formatDate = (date: any) => {
  if (!date) return ''
  // If it's a Firestore Timestamp, convert to date
  const dateObj = date instanceof Timestamp ? date.toDate() : new Date(date)
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  }).format(dateObj)
}

// Watch for filter changes - reset pagination when filters change
watch([() => selectedStartDate.value, () => selectedEndDate.value], () => {
  if (selectedStartDate.value && selectedEndDate.value) {
    currentPage.value = 1
    fetchSearches(true) // Reset pagination
    fetchMetrics()
  }
})

// Handle route query parameters
const route = useRoute()

// Initialize
onMounted(async () => {
  await orgStore.fetchOrgData()
  
  // Check for category in route query and apply filter
  const categoryParam = route.query.category as string
  if (categoryParam) {
    filters.value.categories = [categoryParam]
  }
  
  // Fetch searches and metrics independently
  fetchSearches(true) // Reset pagination on initial load
  fetchMetrics() // Fetch metrics independently, don't block page
})

// Watch for route changes to update filters
watch(
  () => route.query.category,
  (newCategory) => {
    if (newCategory && typeof newCategory === 'string') {
      filters.value.categories = [newCategory]
    } else {
      filters.value.categories = []
    }
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[10] || (_cache[10] = _createElementVNode("div", null, [
          _createElementVNode("h1", { class: "text-3xl font-bold text-white mb-4" }, "Search History"),
          _createElementVNode("p", { class: "text-gray-400" }, "View and analyze your organization's search data")
        ], -1)),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            onClick: refreshSearches,
            class: "inline-flex items-center gap-2 rounded-lg border border-gray-700 bg-dark px-4 py-2 text-sm font-medium text-gray-300 hover:border-primary/30 hover:bg-primary/10 hover:text-primary transition-colors",
            disabled: loading.value
          }, [
            (_openBlock(), _createElementBlock("svg", {
              class: _normalizeClass(["h-4 w-4", { 'animate-spin': loading.value }]),
              fill: "none",
              viewBox: "0 0 24 24",
              stroke: "currentColor"
            }, _cache[9] || (_cache[9] = [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
              }, null, -1)
            ]), 2)),
            _createTextVNode(" " + _toDisplayString(loading.value ? 'Refreshing...' : 'Refresh'), 1)
          ], 8, _hoisted_4)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "flex items-center justify-between" }, [
          _createElementVNode("h3", { class: "text-sm font-medium text-gray-400" }, "Search Volume"),
          _createElementVNode("svg", {
            class: "h-5 w-5 text-primary",
            fill: "none",
            viewBox: "0 0 24 24",
            stroke: "currentColor"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            })
          ])
        ], -1)),
        (loadingMetrics.value || !metricsInitialized.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[11] || (_cache[11] = [
              _createElementVNode("div", { class: "h-9 bg-gray-700/50 rounded animate-pulse w-24" }, null, -1),
              _createElementVNode("div", { class: "h-4 w-32 bg-gray-700/50 rounded animate-pulse" }, null, -1)
            ])))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("p", _hoisted_9, _toDisplayString(searchVolume.value), 1),
              _cache[12] || (_cache[12] = _createElementVNode("p", { class: "mt-1 text-sm text-gray-400" }, "Total searches in period", -1))
            ]))
      ]),
      _createElementVNode("div", _hoisted_10, [
        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "flex items-center justify-between" }, [
          _createElementVNode("h3", { class: "text-sm font-medium text-gray-400" }, "Average Order Value"),
          _createElementVNode("svg", {
            class: "h-5 w-5 text-primary",
            fill: "none",
            viewBox: "0 0 24 24",
            stroke: "currentColor"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            })
          ])
        ], -1)),
        (loadingMetrics.value || !metricsInitialized.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _cache[14] || (_cache[14] = [
              _createElementVNode("div", { class: "h-9 bg-gray-700/50 rounded animate-pulse w-28" }, null, -1),
              _createElementVNode("div", { class: "h-4 w-40 bg-gray-700/50 rounded animate-pulse" }, null, -1)
            ])))
          : (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("p", _hoisted_13, _toDisplayString(formattedAOV.value), 1),
              _cache[15] || (_cache[15] = _createElementVNode("p", { class: "mt-1 text-sm text-gray-400" }, "Average order value from conversions", -1))
            ]))
      ]),
      _createElementVNode("div", _hoisted_14, [
        _cache[19] || (_cache[19] = _createElementVNode("div", { class: "flex items-center justify-between" }, [
          _createElementVNode("h3", { class: "text-sm font-medium text-gray-400" }, "Conversion Rate"),
          _createElementVNode("svg", {
            class: "h-5 w-5 text-primary",
            fill: "none",
            viewBox: "0 0 24 24",
            stroke: "currentColor"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
            })
          ])
        ], -1)),
        (loadingMetrics.value || !metricsInitialized.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, _cache[17] || (_cache[17] = [
              _createElementVNode("div", { class: "h-9 bg-gray-700/50 rounded animate-pulse w-20" }, null, -1),
              _createElementVNode("div", { class: "h-4 w-36 bg-gray-700/50 rounded animate-pulse" }, null, -1)
            ])))
          : (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("p", _hoisted_17, _toDisplayString(formattedConversionRate.value), 1),
              _cache[18] || (_cache[18] = _createElementVNode("p", { class: "mt-1 text-sm text-gray-400" }, "Searches resulting in purchase", -1))
            ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _cache[20] || (_cache[20] = _createElementVNode("div", { class: "pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3" }, [
              _createElementVNode("svg", {
                class: "h-5 w-5 text-gray-400",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                })
              ])
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchTerm).value = $event)),
              type: "search",
              class: "block w-full rounded-lg border border-gray-700 bg-dark pl-10 pr-3 py-2 text-sm text-gray-100 placeholder-gray-400 focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary",
              placeholder: "Search queries..."
            }, null, 512), [
              [_vModelText, searchTerm.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (showDatePicker.value = !showDatePicker.value)),
              class: "date-picker-trigger flex items-center gap-2 bg-dark border border-gray-700 rounded-lg px-3 py-2 text-sm text-gray-100 hover:border-primary focus:outline-none focus:ring-1 focus:ring-primary"
            }, [
              _cache[21] || (_cache[21] = _createElementVNode("svg", {
                class: "h-5 w-5 text-gray-400",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                })
              ], -1)),
              _createElementVNode("span", null, _toDisplayString(formatDateRange.value), 1)
            ]),
            (showDatePicker.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("button", {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (changeMonth(-1))),
                      class: "p-1 hover:bg-gray-700/50 rounded-lg text-gray-400 hover:text-white"
                    }, _cache[22] || (_cache[22] = [
                      _createElementVNode("svg", {
                        class: "h-5 w-5",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M15 19l-7-7 7-7"
                        })
                      ], -1)
                    ])),
                    _createElementVNode("h3", _hoisted_25, _toDisplayString(currentMonthYear.value), 1),
                    _createElementVNode("button", {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (changeMonth(1))),
                      class: "p-1 hover:bg-gray-700/50 rounded-lg text-gray-400 hover:text-white"
                    }, _cache[23] || (_cache[23] = [
                      _createElementVNode("svg", {
                        class: "h-5 w-5",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M9 5l7 7-7 7"
                        })
                      ], -1)
                    ]))
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'], (day) => {
                      return _createElementVNode("div", {
                        key: day,
                        class: "text-center text-xs font-medium text-gray-400 py-1"
                      }, _toDisplayString(day), 1)
                    }), 64)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(calendarDays.value, (date, index) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: index,
                        onClick: ($event: any) => (selectDate(date)),
                        class: _normalizeClass([
                    'text-center py-1 text-sm rounded transition-colors',
                    date.isCurrentMonth ? 'text-gray-100' : 'text-gray-600',
                    isSelectedDate(date) ? 'bg-primary text-white' : 'hover:bg-gray-700/50',
                    isInRange(date) ? 'bg-primary/20' : ''
                  ]),
                        disabled: !date.isCurrentMonth
                      }, _toDisplayString(date.day), 11, _hoisted_27))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(datePresets, (preset) => {
                      return _createElementVNode("button", {
                        key: preset.value,
                        onClick: ($event: any) => (selectDatePreset(preset)),
                        class: "text-sm text-gray-400 hover:text-white py-1 px-2 rounded transition-colors hover:bg-gray-700/50"
                      }, _toDisplayString(preset.label), 9, _hoisted_29)
                    }), 64))
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("button", {
                      onClick: _cache[4] || (_cache[4] = () => { showDatePicker.value = false }),
                      class: "text-sm text-gray-400 hover:text-white py-1 px-3 rounded transition-colors hover:bg-gray-700/50"
                    }, " Cancel "),
                    _createElementVNode("div", { class: "flex gap-2" }, [
                      _createElementVNode("button", {
                        onClick: setToday,
                        class: "text-sm text-gray-400 hover:text-white py-1 px-3 rounded transition-colors hover:bg-gray-700/50"
                      }, " Today "),
                      _createElementVNode("button", {
                        onClick: applyDateRange,
                        class: "text-sm text-white bg-primary py-1 px-3 rounded transition-colors hover:bg-primary/90"
                      }, " Apply ")
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(conversionFilters, (status) => {
                return _createElementVNode("button", {
                  key: status.value,
                  onClick: ($event: any) => (toggleConversionFilter(status.value)),
                  class: _normalizeClass([
                  'flex items-center gap-1.5 rounded px-2.5 py-1 text-sm font-medium transition-colors',
                  filters.value.conversion === status.value
                    ? 'bg-primary text-white'
                    : 'text-gray-400 hover:bg-gray-700/50 hover:text-white'
                ])
                }, [
                  (status.value !== '')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_34, [
                        _createElementVNode("span", {
                          class: _normalizeClass([
                    'relative inline-flex h-2 w-2 rounded-full',
                    status.value === 'converted' ? 'bg-emerald-500' : 'bg-gray-500'
                  ])
                        }, null, 2)
                      ]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(status.label), 1)
                ], 10, _hoisted_33)
              }), 64))
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("button", {
                onClick: toggleIncludeSpam,
                class: _normalizeClass(["relative inline-flex h-6 w-11 items-center rounded-full", includeSpam.value ? 'bg-orange-500/30' : 'bg-gray-700'])
              }, [
                _cache[24] || (_cache[24] = _createElementVNode("span", { class: "sr-only" }, "Include spam searches", -1)),
                _createElementVNode("span", {
                  class: _normalizeClass(["inline-block h-4 w-4 transform rounded-full bg-white transition", includeSpam.value ? 'translate-x-6' : 'translate-x-1'])
                }, null, 2)
              ], 2),
              _cache[25] || (_cache[25] = _createElementVNode("span", { class: "text-sm text-gray-400" }, "Include Spam", -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filters.value.categories, (category) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: category,
                  class: "inline-flex items-center gap-1 rounded-full bg-primary/20 px-2 py-1 text-xs font-medium text-primary"
                }, [
                  _createTextVNode(_toDisplayString(formatCategory(category)) + " ", 1),
                  _createElementVNode("button", {
                    onClick: ($event: any) => (toggleCategory(category)),
                    class: "text-primary/70 hover:text-primary",
                    "aria-label": "Remove category"
                  }, "×", 8, _hoisted_39)
                ]))
              }), 128)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((categorySearchQuery).value = $event)),
                type: "text",
                class: "flex-1 min-w-[120px] bg-transparent text-sm text-gray-100 placeholder-gray-400 focus:outline-none",
                placeholder: "Filter categories...",
                onFocus: _cache[6] || (_cache[6] = ($event: any) => (showCategorySuggestions.value = true)),
                onKeydown: _withKeys(handleBackspace, ["backspace"])
              }, null, 544), [
                [_vModelText, categorySearchQuery.value]
              ])
            ])
          ]),
          (showCategorySuggestions.value && filteredAvailableCategories.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredAvailableCategories.value, (category) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: category,
                    onClick: ($event: any) => (selectCategory(category)),
                    class: "w-full px-3 py-2 text-left text-sm text-gray-200 transition-colors hover:bg-gray-700/50"
                  }, _toDisplayString(formatCategory(category)), 9, _hoisted_41))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        (hasActiveFilters.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
              _createElementVNode("span", _hoisted_43, " Showing " + _toDisplayString(paginatedSearches.value.length) + " results ", 1),
              _createElementVNode("button", {
                onClick: clearFilters,
                class: "text-sm text-gray-400 hover:text-white"
              }, " Clear filters ")
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (!loading.value && (hasPreviousPage.value || hasNextPage.value || currentPage.value > 1))
      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            _cache[26] || (_cache[26] = _createElementVNode("span", null, "Page", -1)),
            _createElementVNode("span", _hoisted_46, _toDisplayString(currentPage.value), 1),
            _createElementVNode("span", _hoisted_47, "(" + _toDisplayString(paginatedSearches.value.length) + " results)", 1)
          ]),
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("button", {
              onClick: goToFirstPage,
              disabled: !hasPreviousPage.value,
              class: "inline-flex items-center justify-center w-8 h-8 rounded-lg border border-gray-700 bg-dark text-gray-300 transition-colors disabled:opacity-50 disabled:cursor-not-allowed hover:border-primary/30 hover:bg-primary/10 hover:text-primary",
              title: "First page"
            }, _cache[27] || (_cache[27] = [
              _createElementVNode("svg", {
                class: "h-4 w-4",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M11 19l-7-7 7-7m8 14l-7-7 7-7"
                })
              ], -1)
            ]), 8, _hoisted_49),
            _createElementVNode("button", {
              onClick: previousPage,
              disabled: !hasPreviousPage.value,
              class: "inline-flex items-center justify-center w-8 h-8 rounded-lg border border-gray-700 bg-dark text-gray-300 transition-colors disabled:opacity-50 disabled:cursor-not-allowed hover:border-primary/30 hover:bg-primary/10 hover:text-primary",
              title: "Previous page"
            }, _cache[28] || (_cache[28] = [
              _createElementVNode("svg", {
                class: "h-4 w-4",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M15 19l-7-7 7-7"
                })
              ], -1)
            ]), 8, _hoisted_50),
            _createElementVNode("button", {
              onClick: nextPage,
              disabled: !hasNextPage.value,
              class: "inline-flex items-center justify-center w-8 h-8 rounded-lg border border-gray-700 bg-dark text-gray-300 transition-colors disabled:opacity-50 disabled:cursor-not-allowed hover:border-primary/30 hover:bg-primary/10 hover:text-primary",
              title: "Next page"
            }, _cache[29] || (_cache[29] = [
              _createElementVNode("svg", {
                class: "h-4 w-4",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M9 5l7 7-7 7"
                })
              ], -1)
            ]), 8, _hoisted_51)
          ])
        ]))
      : _createCommentVNode("", true),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("table", _hoisted_54, [
              _cache[31] || (_cache[31] = _createElementVNode("thead", { class: "border-b border-gray-700" }, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    scope: "col",
                    class: "px-6 py-4 text-center text-xs font-medium text-gray-300 uppercase"
                  }, " Search Time "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "px-6 py-4 text-center text-xs font-medium text-gray-300 uppercase"
                  }, " Search Query "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "px-6 py-4 text-center text-xs font-medium text-gray-300 uppercase"
                  }, " Product Link "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "px-6 py-4 text-center text-xs font-medium text-gray-300 uppercase"
                  }, " Categories "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "px-6 py-4 text-center text-xs font-medium text-gray-300 uppercase"
                  }, " Converted "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "px-4 py-4 text-center text-xs font-medium text-gray-300 uppercase"
                  }, " Details ")
                ])
              ], -1)),
              _createElementVNode("tbody", _hoisted_55, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                  return _createElementVNode("tr", {
                    key: `skeleton-${i}`,
                    class: "hover:bg-gray-700/20"
                  }, _cache[30] || (_cache[30] = [
                    _createElementVNode("td", { class: "px-6 py-4 whitespace-nowrap" }, [
                      _createElementVNode("div", { class: "h-4 bg-gray-700/50 rounded animate-pulse w-24 mx-auto" })
                    ], -1),
                    _createElementVNode("td", { class: "px-6 py-4" }, [
                      _createElementVNode("div", { class: "flex items-start gap-2" }, [
                        _createElementVNode("div", { class: "h-4 bg-gray-700/50 rounded animate-pulse w-48" })
                      ])
                    ], -1),
                    _createElementVNode("td", { class: "px-6 py-4" }, [
                      _createElementVNode("div", { class: "h-4 bg-gray-700/50 rounded animate-pulse w-40" })
                    ], -1),
                    _createElementVNode("td", { class: "px-6 py-4" }, [
                      _createElementVNode("div", { class: "flex flex-wrap gap-1" }, [
                        _createElementVNode("div", { class: "h-6 bg-gray-700/50 rounded-md animate-pulse w-16" }),
                        _createElementVNode("div", { class: "h-6 bg-gray-700/50 rounded-md animate-pulse w-20" })
                      ])
                    ], -1),
                    _createElementVNode("td", { class: "px-6 py-4 text-center" }, [
                      _createElementVNode("div", { class: "h-8 w-8 bg-gray-700/50 rounded-full animate-pulse mx-auto" })
                    ], -1),
                    _createElementVNode("td", { class: "px-4 py-4 whitespace-nowrap text-right" }, [
                      _createElementVNode("div", { class: "flex items-center gap-2 justify-end" }, [
                        _createElementVNode("div", { class: "h-8 w-8 bg-gray-700/50 rounded-lg animate-pulse" }),
                        _createElementVNode("div", { class: "h-8 w-8 bg-gray-700/50 rounded-lg animate-pulse" }),
                        _createElementVNode("div", { class: "h-8 w-8 bg-gray-700/50 rounded-lg animate-pulse" })
                      ])
                    ], -1)
                  ]))
                }), 64))
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_56, [
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("table", _hoisted_58, [
              _cache[39] || (_cache[39] = _createElementVNode("thead", { class: "border-b border-gray-700" }, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    scope: "col",
                    class: "px-6 py-4 text-center text-xs font-medium text-gray-300 uppercase"
                  }, " Search Time "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "px-6 py-4 text-center text-xs font-medium text-gray-300 uppercase"
                  }, " Search Query "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "px-6 py-4 text-center text-xs font-medium text-gray-300 uppercase"
                  }, " Product Link "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "px-6 py-4 text-center text-xs font-medium text-gray-300 uppercase"
                  }, " Categories "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "px-6 py-4 text-center text-xs font-medium text-gray-300 uppercase"
                  }, " Converted "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "px-4 py-4 text-center text-xs font-medium text-gray-300 uppercase"
                  }, " Details ")
                ])
              ], -1)),
              _createElementVNode("tbody", _hoisted_59, [
                (!paginatedSearches.value.length)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_60, _cache[32] || (_cache[32] = [
                      _createElementVNode("td", {
                        colspan: "6",
                        class: "px-6 py-4 text-sm text-gray-500 text-center"
                      }, " No searches found ", -1)
                    ])))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(paginatedSearches.value, (search) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: search.id,
                        class: "hover:bg-gray-700/20 transition-colors"
                      }, [
                        _createElementVNode("td", _hoisted_61, _toDisplayString(formatDate(search.created_at)), 1),
                        _createElementVNode("td", _hoisted_62, [
                          _createElementVNode("div", _hoisted_63, [
                            _createElementVNode("div", _hoisted_64, _toDisplayString(search.query), 1),
                            (search.enriched_data?.is_potential_spam)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_65, _cache[33] || (_cache[33] = [
                                  _createElementVNode("svg", {
                                    class: "h-4 w-4 text-amber-500",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    stroke: "currentColor"
                                  }, [
                                    _createElementVNode("path", {
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                      "stroke-width": "2",
                                      d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                                    })
                                  ], -1),
                                  _createElementVNode("div", { class: "absolute left-1/2 -translate-x-1/2 bottom-full mb-2 hidden group-hover:block" }, [
                                    _createElementVNode("div", { class: "bg-dark-secondary text-xs text-amber-500 rounded-md px-2 py-1 whitespace-nowrap border border-gray-700" }, " Potential Spam ")
                                  ], -1)
                                ])))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_66, [
                          _createElementVNode("div", _hoisted_67, [
                            (search.response?.product_url)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  href: getFullProductUrl(search.response.product_url),
                                  target: "_blank",
                                  rel: "noopener noreferrer",
                                  class: "text-blue-400 hover:text-blue-300 flex items-start"
                                }, [
                                  _createElementVNode("span", _hoisted_69, _toDisplayString(search.response.product_url), 1),
                                  _cache[34] || (_cache[34] = _createElementVNode("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    class: "h-4 w-4 ml-1 flex-shrink-0 mt-1",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    stroke: "currentColor"
                                  }, [
                                    _createElementVNode("path", {
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                      "stroke-width": "2",
                                      d: "M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                                    })
                                  ], -1))
                                ], 8, _hoisted_68))
                              : (_openBlock(), _createElementBlock("span", _hoisted_70, "-"))
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_71, [
                          (search.enriched_data?.enriched_categories?.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(search.enriched_data.enriched_categories, (category) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: category,
                                    class: "inline-flex items-center px-2 py-0.5 rounded-md text-xs font-medium bg-gray-700/50 text-gray-300"
                                  }, _toDisplayString(formatCategory(category)), 1))
                                }), 128))
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_73, "-"))
                        ]),
                        _createElementVNode("td", _hoisted_74, [
                          (search.has_converted)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_75, _cache[35] || (_cache[35] = [
                                _createElementVNode("svg", {
                                  class: "w-5 h-5",
                                  fill: "none",
                                  viewBox: "0 0 24 24",
                                  stroke: "currentColor"
                                }, [
                                  _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    "stroke-width": "2",
                                    d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                  })
                                ], -1)
                              ])))
                            : (_openBlock(), _createElementBlock("span", _hoisted_76, "-"))
                        ]),
                        _createElementVNode("td", _hoisted_77, [
                          _createElementVNode("div", _hoisted_78, [
                            _createElementVNode("button", {
                              onClick: ($event: any) => (toggleSpamStatus(search)),
                              class: _normalizeClass(["inline-flex items-center justify-center w-8 h-8 rounded-lg border", [
                        search.enriched_data?.is_potential_spam 
                          ? 'border-amber-500/30 text-amber-500 hover:border-amber-500/50 hover:bg-amber-500/10'
                          : 'border-gray-700 text-gray-400 hover:border-amber-500/30 hover:bg-amber-500/10 hover:text-amber-500'
                      ]]),
                              title: search.enriched_data?.is_potential_spam ? 'Mark as Not Spam' : 'Mark as Spam'
                            }, _cache[36] || (_cache[36] = [
                              _createElementVNode("svg", {
                                class: "h-4 w-4",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                                })
                              ], -1)
                            ]), 10, _hoisted_79),
                            _createElementVNode("button", {
                              onClick: ($event: any) => (handleDeleteSearch(search)),
                              class: "inline-flex items-center justify-center w-8 h-8 rounded-lg border border-red-500/30 text-red-500 hover:border-red-500/50 hover:bg-red-500/10 transition-colors",
                              title: "Delete Search"
                            }, _cache[37] || (_cache[37] = [
                              _createElementVNode("svg", {
                                class: "h-4 w-4",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                })
                              ], -1)
                            ]), 8, _hoisted_80),
                            _createElementVNode("button", {
                              onClick: ($event: any) => (openDetailsModal(search)),
                              class: "inline-flex items-center justify-center w-8 h-8 rounded-lg border border-gray-700 text-gray-300 hover:border-primary/30 hover:bg-primary/10 hover:text-primary transition-colors",
                              title: "View Details"
                            }, _cache[38] || (_cache[38] = [
                              _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                class: "h-4 w-4",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                }),
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                                })
                              ], -1)
                            ]), 8, _hoisted_81)
                          ])
                        ])
                      ]))
                    }), 128))
              ])
            ])
          ]),
          (hasPreviousPage.value || hasNextPage.value || currentPage.value > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                _createElementVNode("div", _hoisted_83, [
                  _cache[40] || (_cache[40] = _createElementVNode("span", null, "Showing", -1)),
                  _createElementVNode("span", _hoisted_84, _toDisplayString(paginatedSearches.value.length), 1),
                  _cache[41] || (_cache[41] = _createElementVNode("span", null, "results on page", -1)),
                  _createElementVNode("span", _hoisted_85, _toDisplayString(currentPage.value), 1)
                ]),
                _createElementVNode("div", _hoisted_86, [
                  _createElementVNode("button", {
                    onClick: goToFirstPage,
                    disabled: !hasPreviousPage.value,
                    class: "inline-flex items-center gap-1 rounded-lg border border-gray-700 bg-dark px-3 py-2 text-sm font-medium text-gray-300 transition-colors disabled:opacity-50 disabled:cursor-not-allowed hover:border-primary/30 hover:bg-primary/10 hover:text-primary"
                  }, _cache[42] || (_cache[42] = [
                    _createElementVNode("svg", {
                      class: "h-4 w-4",
                      fill: "none",
                      viewBox: "0 0 24 24",
                      stroke: "currentColor"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M11 19l-7-7 7-7m8 14l-7-7 7-7"
                      })
                    ], -1),
                    _createTextVNode(" First ")
                  ]), 8, _hoisted_87),
                  _createElementVNode("button", {
                    onClick: previousPage,
                    disabled: !hasPreviousPage.value,
                    class: "inline-flex items-center gap-1 rounded-lg border border-gray-700 bg-dark px-3 py-2 text-sm font-medium text-gray-300 transition-colors disabled:opacity-50 disabled:cursor-not-allowed hover:border-primary/30 hover:bg-primary/10 hover:text-primary"
                  }, _cache[43] || (_cache[43] = [
                    _createElementVNode("svg", {
                      class: "h-4 w-4",
                      fill: "none",
                      viewBox: "0 0 24 24",
                      stroke: "currentColor"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M15 19l-7-7 7-7"
                      })
                    ], -1),
                    _createTextVNode(" Previous ")
                  ]), 8, _hoisted_88),
                  _createElementVNode("button", {
                    onClick: nextPage,
                    disabled: !hasNextPage.value,
                    class: "inline-flex items-center gap-1 rounded-lg border border-gray-700 bg-dark px-3 py-2 text-sm font-medium text-gray-300 transition-colors disabled:opacity-50 disabled:cursor-not-allowed hover:border-primary/30 hover:bg-primary/10 hover:text-primary"
                  }, _cache[44] || (_cache[44] = [
                    _createTextVNode(" Next "),
                    _createElementVNode("svg", {
                      class: "h-4 w-4",
                      fill: "none",
                      viewBox: "0 0 24 24",
                      stroke: "currentColor"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M9 5l7 7-7 7"
                      })
                    ], -1)
                  ]), 8, _hoisted_89)
                ])
              ]))
            : _createCommentVNode("", true)
        ])),
    _createVNode(BaseModal, {
      modelValue: showDetailsModal.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((showDetailsModal).value = $event)),
      "max-width": "80rem"
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", { class: "flex items-center justify-between" }, [
          _cache[46] || (_cache[46] = _createElementVNode("h3", { class: "text-lg font-medium text-white" }, "Search Details", -1)),
          _createElementVNode("button", {
            onClick: closeDetailsModal,
            class: "text-gray-400 hover:text-gray-300 focus:outline-none"
          }, _cache[45] || (_cache[45] = [
            _createElementVNode("svg", {
              class: "h-6 w-6",
              fill: "none",
              viewBox: "0 0 24 24",
              stroke: "currentColor"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M6 18L18 6M6 6l12 12"
              })
            ], -1)
          ]))
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_90, [
          _createElementVNode("span", _hoisted_91, "ID: " + _toDisplayString(selectedSearch.value?.id), 1),
          _createElementVNode("button", {
            onClick: _cache[7] || (_cache[7] = () => selectedSearch.value && handleDeleteSearch(selectedSearch.value)),
            class: "inline-flex items-center gap-2 rounded-lg border border-red-500/30 bg-red-500/10 px-4 py-2 text-sm font-medium text-red-500 hover:bg-red-500/20 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 focus:ring-offset-dark disabled:opacity-50 disabled:cursor-not-allowed",
            disabled: isDeleting.value
          }, [
            (isDeleting.value)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_93, _cache[47] || (_cache[47] = [
                  _createElementVNode("circle", {
                    class: "opacity-25",
                    cx: "12",
                    cy: "12",
                    r: "10",
                    stroke: "currentColor",
                    "stroke-width": "4"
                  }, null, -1),
                  _createElementVNode("path", {
                    class: "opacity-75",
                    fill: "currentColor",
                    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  }, null, -1)
                ])))
              : (_openBlock(), _createElementBlock("svg", _hoisted_94, _cache[48] || (_cache[48] = [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                  }, null, -1)
                ]))),
            _createTextVNode(" " + _toDisplayString(isDeleting.value ? 'Deleting...' : 'Delete Search'), 1)
          ], 8, _hoisted_92)
        ])
      ]),
      default: _withCtx(() => [
        (selectedSearch.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
              _createElementVNode("div", _hoisted_96, [
                _createElementVNode("div", _hoisted_97, [
                  _createElementVNode("div", _hoisted_98, [
                    _createElementVNode("div", _hoisted_99, [
                      _cache[49] || (_cache[49] = _createElementVNode("h4", { class: "text-sm font-medium text-gray-400" }, "Query", -1)),
                      _createElementVNode("span", _hoisted_100, _toDisplayString(formatDate(selectedSearch.value.created_at)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_101, [
                      _createElementVNode("p", _hoisted_102, _toDisplayString(selectedSearch.value.query), 1),
                      (selectedSearch.value.enriched_data?.is_potential_spam)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_103, _cache[50] || (_cache[50] = [
                            _createElementVNode("svg", {
                              class: "h-5 w-5 text-amber-500",
                              fill: "none",
                              viewBox: "0 0 24 24",
                              stroke: "currentColor"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                              })
                            ], -1),
                            _createElementVNode("div", { class: "absolute left-1/2 -translate-x-1/2 bottom-full mb-2 hidden group-hover:block" }, [
                              _createElementVNode("div", { class: "bg-dark-secondary text-xs text-amber-500 rounded-md px-2 py-1 whitespace-nowrap border border-gray-700" }, " Potential Spam ")
                            ], -1)
                          ])))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_104, [
                    _createElementVNode("div", _hoisted_105, [
                      _createElementVNode("div", null, [
                        _cache[52] || (_cache[52] = _createElementVNode("h4", { class: "text-sm font-medium text-gray-400 mb-2" }, "Conversion Status", -1)),
                        (selectedSearch.value.has_converted)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_106, _cache[51] || (_cache[51] = [
                              _createElementVNode("svg", {
                                class: "w-4 h-4 mr-1",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                })
                              ], -1),
                              _createTextVNode(" Converted ")
                            ])))
                          : (_openBlock(), _createElementBlock("span", _hoisted_107, "Not Converted"))
                      ]),
                      (selectedSearch.value.conversion_data?.order_id)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                            _cache[53] || (_cache[53] = _createElementVNode("h4", { class: "text-sm font-medium text-gray-400 mb-2" }, "Order Amount", -1)),
                            _createElementVNode("p", _hoisted_109, "$" + _toDisplayString(selectedSearch.value.conversion_data.amount), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (selectedSearch.value.conversion_data?.order_id)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                          _createElementVNode("a", {
                            href: `https://${_unref(orgStore).orgData?.keys?.shopify?.storeName}.myshopify.com/admin/orders/${selectedSearch.value.conversion_data.order_id}`,
                            target: "_blank",
                            class: "text-xs text-blue-400 hover:text-blue-300 flex items-center gap-1"
                          }, _cache[54] || (_cache[54] = [
                            _createTextVNode(" View Order in Shopify "),
                            _createElementVNode("svg", {
                              xmlns: "http://www.w3.org/2000/svg",
                              class: "h-3 w-3",
                              fill: "none",
                              viewBox: "0 0 24 24",
                              stroke: "currentColor"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                              })
                            ], -1)
                          ]), 8, _hoisted_111)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_112, [
                    _cache[55] || (_cache[55] = _createElementVNode("h4", { class: "text-sm font-medium text-gray-400" }, "Categories", -1)),
                    _createElementVNode("div", _hoisted_113, [
                      (selectedSearch.value.enriched_data?.enriched_categories?.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedSearch.value.enriched_data.enriched_categories, (category) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: category,
                                onClick: ($event: any) => (filterByCategory(category)),
                                class: "inline-flex items-center px-2.5 py-1 rounded-md text-xs font-medium bg-gray-700/50 text-gray-300 hover:bg-gray-600/50 hover:text-white transition-colors"
                              }, _toDisplayString(formatCategory(category)), 9, _hoisted_115))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("p", _hoisted_116, "-"))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_117, [
                    _cache[57] || (_cache[57] = _createElementVNode("h4", { class: "text-sm font-medium text-gray-400" }, "Product URL", -1)),
                    (selectedSearch.value.response?.product_url)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: getFullProductUrl(selectedSearch.value.response.product_url),
                          target: "_blank",
                          rel: "noopener noreferrer",
                          class: "mt-2 text-blue-400 hover:text-blue-300 flex items-start"
                        }, [
                          _createElementVNode("span", _hoisted_119, _toDisplayString(selectedSearch.value.response.product_url), 1),
                          _cache[56] || (_cache[56] = _createElementVNode("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            class: "h-4 w-4 ml-1 flex-shrink-0 mt-1",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            stroke: "currentColor"
                          }, [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                            })
                          ], -1))
                        ], 8, _hoisted_118))
                      : (_openBlock(), _createElementBlock("p", _hoisted_120, "-"))
                  ]),
                  _createElementVNode("div", null, [
                    _cache[58] || (_cache[58] = _createElementVNode("h4", { class: "text-sm font-medium text-gray-400 mb-2" }, "Metadata", -1)),
                    (selectedSearch.value.meta_data && Object.keys(selectedSearch.value.meta_data).length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedSearch.value.meta_data, (value, key) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: key,
                              class: "inline-flex items-center px-2.5 py-1 rounded-md text-xs font-medium bg-blue-500/20 text-blue-300"
                            }, _toDisplayString(key) + ": " + _toDisplayString(value), 1))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_122, "-"))
                  ])
                ]),
                (selectedSearch.value.enriched_data)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                      _cache[61] || (_cache[61] = _createElementVNode("h4", { class: "text-lg font-medium text-white border-b border-gray-700 pb-2" }, "Search Analysis", -1)),
                      (selectedSearch.value.enriched_data.key_search_terms?.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
                            _cache[59] || (_cache[59] = _createElementVNode("h5", { class: "text-sm font-medium text-gray-400" }, "Key Search Terms", -1)),
                            _createElementVNode("div", _hoisted_125, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedSearch.value.enriched_data.key_search_terms, (term) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  key: term,
                                  class: "inline-flex items-center px-2.5 py-1 rounded-md text-xs font-medium bg-gray-700/50 text-gray-300"
                                }, _toDisplayString(term), 1))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (selectedSearch.value.enriched_data.query_intent)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_126, [
                            _cache[60] || (_cache[60] = _createElementVNode("h5", { class: "text-sm font-medium text-gray-400" }, "Query Intent", -1)),
                            _createElementVNode("div", _hoisted_127, [
                              _createElementVNode("span", _hoisted_128, _toDisplayString(selectedSearch.value.enriched_data.query_intent), 1),
                              (selectedSearch.value.enriched_data.intent_score !== undefined)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_129, " (" + _toDisplayString(selectedSearch.value.enriched_data.intent_score) + ") ", 1))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_130, [
                (selectedSearch.value.response)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_131, [
                      _cache[65] || (_cache[65] = _createElementVNode("h4", { class: "text-lg font-medium text-white border-b border-gray-700 pb-2" }, "Personalized Content", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedSearch.value.response, (value, key) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: key,
                          class: "pb-4"
                        }, [
                          _createElementVNode("h5", _hoisted_132, _toDisplayString(formatKey(key)), 1),
                          (Array.isArray(value))
                            ? (_openBlock(), _createElementBlock("ul", _hoisted_133, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (item, index) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: index,
                                    class: "flex items-start text-white"
                                  }, [
                                    _cache[62] || (_cache[62] = _createElementVNode("svg", {
                                      xmlns: "http://www.w3.org/2000/svg",
                                      class: "h-5 w-5 mr-3 text-green-500 flex-shrink-0",
                                      fill: "none",
                                      viewBox: "0 0 24 24",
                                      stroke: "currentColor"
                                    }, [
                                      _createElementVNode("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M5 13l4 4L19 7"
                                      })
                                    ], -1)),
                                    _createTextVNode(" " + _toDisplayString(item), 1)
                                  ]))
                                }), 128))
                              ]))
                            : (typeof value === 'boolean')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_134, [
                                  value
                                    ? (_openBlock(), _createElementBlock("svg", _hoisted_135, _cache[63] || (_cache[63] = [
                                        _createElementVNode("path", {
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                          "stroke-width": "2",
                                          d: "M5 13l4 4L19 7"
                                        }, null, -1)
                                      ])))
                                    : (_openBlock(), _createElementBlock("svg", _hoisted_136, _cache[64] || (_cache[64] = [
                                        _createElementVNode("path", {
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                          "stroke-width": "2",
                                          d: "M6 18L18 6M6 6l12 12"
                                        }, null, -1)
                                      ]))),
                                  _createElementVNode("span", _hoisted_137, _toDisplayString(value ? 'Yes' : 'No'), 1)
                                ]))
                              : (typeof value === 'number')
                                ? (_openBlock(), _createElementBlock("p", _hoisted_138, _toDisplayString(value), 1))
                                : (_openBlock(), _createElementBlock("p", _hoisted_139, _toDisplayString(value), 1))
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (selectedSearch.value.integration_data)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_140, [
                      _cache[69] || (_cache[69] = _createElementVNode("h4", { class: "text-lg font-medium text-white border-b border-gray-700 pb-2" }, "Integration Data", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedSearch.value.integration_data, (value, key) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: key,
                          class: "pb-4"
                        }, [
                          _createElementVNode("h5", _hoisted_141, _toDisplayString(formatKey(key)), 1),
                          (Array.isArray(value))
                            ? (_openBlock(), _createElementBlock("ul", _hoisted_142, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (item, index) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: index,
                                    class: "flex items-start text-white"
                                  }, [
                                    _cache[66] || (_cache[66] = _createElementVNode("svg", {
                                      xmlns: "http://www.w3.org/2000/svg",
                                      class: "h-5 w-5 mr-3 text-blue-500 flex-shrink-0",
                                      fill: "none",
                                      viewBox: "0 0 24 24",
                                      stroke: "currentColor"
                                    }, [
                                      _createElementVNode("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M5 13l4 4L19 7"
                                      })
                                    ], -1)),
                                    _createTextVNode(" " + _toDisplayString(item), 1)
                                  ]))
                                }), 128))
                              ]))
                            : (typeof value === 'boolean')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_143, [
                                  value
                                    ? (_openBlock(), _createElementBlock("svg", _hoisted_144, _cache[67] || (_cache[67] = [
                                        _createElementVNode("path", {
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                          "stroke-width": "2",
                                          d: "M5 13l4 4L19 7"
                                        }, null, -1)
                                      ])))
                                    : (_openBlock(), _createElementBlock("svg", _hoisted_145, _cache[68] || (_cache[68] = [
                                        _createElementVNode("path", {
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                          "stroke-width": "2",
                                          d: "M6 18L18 6M6 6l12 12"
                                        }, null, -1)
                                      ]))),
                                  _createElementVNode("span", _hoisted_146, _toDisplayString(value ? 'Yes' : 'No'), 1)
                                ]))
                              : (typeof value === 'number')
                                ? (_openBlock(), _createElementBlock("p", _hoisted_147, _toDisplayString(value), 1))
                                : (_openBlock(), _createElementBlock("p", _hoisted_148, _toDisplayString(value), 1))
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})